var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1C5.48068 1 1 5.48068 1 11C1 16.5193 5.48068 21 11 21C16.519 21 21 16.5193 21 11C21 5.48068 16.5193 1 11 1ZM11 1.86938C16.0393 1.86938 20.1305 5.96061 20.1305 10.9999C20.1305 16.0392 16.0393 20.1305 11 20.1305C5.96068 20.1305 1.86945 16.0389 1.86945 10.9999C1.86945 5.96098 5.96068 1.86938 11 1.86938Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5654 4.91328V11.0002C10.5654 11.2402 10.7602 11.435 11.0003 11.435H17.0872C17.3272 11.435 17.522 11.2402 17.522 11.0002C17.522 10.7601 17.3272 10.5653 17.0872 10.5653H11.4352V4.91335C11.4352 4.6733 11.2404 4.47852 11.0003 4.47852C10.7603 4.47852 10.5655 4.6733 10.5655 4.91335L10.5654 4.91328Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIconWhite);
export default __webpack_public_path__ + "static/media/ClockIconWhite.ea001f791896334f2d84ecb036366f82.svg";
export { ForwardRef as ReactComponent };